export function createCancelAttemptId(): string {
  return (
    globalThis.crypto?.randomUUID?.() ??
    `c_${Math.random().toString(36).slice(2)}`
  );
}

export function cancelAttemptTrackingProps(
  cancelAttemptId: string | null | undefined,
): {
  cancel_attempt_id?: string;
  conversationId?: string;
} {
  const id = cancelAttemptId?.trim() || undefined;
  return id ? { cancel_attempt_id: id, conversationId: id } : {};
}

export function cancelFlowTrackingProps(opts: {
  cancelAttemptId?: string | null;
  orderCount?: number | null;
}): {
  cancel_attempt_id?: string;
  conversationId?: string;
  orderCount?: number;
} {
  const orderCount = opts.orderCount;
  return {
    ...cancelAttemptTrackingProps(opts.cancelAttemptId),
    ...(orderCount != null && Number.isFinite(orderCount) ? { orderCount } : {}),
  };
}

export type LeverActionSource = "cancel_flow" | "manage_tab";

export function resolveLeverSource(opts: {
  fromCancelFlowFlag: boolean;
  conversationId?: string | null;
  offerTaken?: string | null;
}): LeverActionSource {
  if (opts.fromCancelFlowFlag) return "cancel_flow";
  if (opts.conversationId?.trim()) return "cancel_flow";
  if (opts.offerTaken?.trim()) return "cancel_flow";
  return "manage_tab";
}

export function leverActionTrackingProps(opts: {
  source: LeverActionSource;
  subscriptionContractId: number;
  orderCount?: number | null;
  cancelAttemptId?: string | null;
}): {
  source: LeverActionSource;
  subscription_contract_id: number;
  cancel_attempt_id?: string;
  conversationId?: string;
  orderCount?: number;
} {
  const contract = { subscription_contract_id: opts.subscriptionContractId };
  if (opts.source !== "cancel_flow") {
    return { source: opts.source, ...contract };
  }
  return {
    source: opts.source,
    ...contract,
    ...cancelFlowTrackingProps({
      cancelAttemptId: opts.cancelAttemptId,
      orderCount: opts.orderCount,
    }),
  };
}
